// Jobs whose generated file can be downloaded straight from the completion toast and the notifications area,
// keyed by job_class. The value is the completion message shown in both.
export const DIRECT_DOWNLOAD_JOBS: Record<string, string> = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- keys are backend job class names
  GenerateUnderwritingModelJob: 'Underwriting model generated successfully.',
};
